import { ParameterType } from '@/study-search/enums';

import { Filter } from '../Filter';
import { IIndexation } from '../../../interfaces';
import { FilterKey, SpecialProgrammesFilterOptionValue } from '@studyportals/search-filters';

export class SpecialProgrammesFilter extends Filter implements IIndexation {
	public constructor() {
		super(FilterKey.SPECIAL_PROGRAMMES, ParameterType.SPECIAL_PROGRAMMES, []);
	}

	public canBeIndexed(): boolean {
		return (
			this.values.length === 1 &&
			(this.values.includes(SpecialProgrammesFilterOptionValue.ERASMUS_MUNDUS) ||
				this.values.includes(SpecialProgrammesFilterOptionValue.JOINT_PROGRAMMES))
		);
	}
}
